import { EntryTypeGroup, ManualEntry, ManualEntryCard } from '../types';
import { contentTypesByEntryTypeGroup } from './constants';

export type BuildTaggingToolDamUrlParams = {
  taggingToolUrl: string;
  contentFeedId: string;
  pickerEntryTypeGroup: EntryTypeGroup;
  persistedManualEntries: ManualEntry[];
  manualAssetCards: ManualEntryCard[] | null;
};

export function buildTaggingToolDamUrl({
  taggingToolUrl,
  contentFeedId,
  pickerEntryTypeGroup,
  persistedManualEntries,
  manualAssetCards,
}: BuildTaggingToolDamUrlParams): string {
  const urlString = `${taggingToolUrl.replace(/\/$/, '')}/dam`;
  const result = new URL(urlString);

  const [selectedEntryType] = contentTypesByEntryTypeGroup[
    pickerEntryTypeGroup
  ];
  result.searchParams.set('entryType', selectedEntryType ?? '');
  result.searchParams.set('contentFeedId', contentFeedId);

  const matchesEntryType = (entry: ManualEntry) =>
    !selectedEntryType || entry.type === selectedEntryType;

  const fromPersisted = persistedManualEntries
    .filter(matchesEntryType)
    .map((entry) => String(entry.entryId));
  const fromCards = (manualAssetCards ?? [])
    .filter(matchesEntryType)
    .map((entry) => String(entry.entryId));

  const preselectedEntryIds = Array.from(
    new Set([...fromPersisted, ...fromCards]),
  );

  if (preselectedEntryIds.length > 0) {
    const joinedIds = preselectedEntryIds.join(',');
    result.searchParams.set('selectedEntryIds', joinedIds);
    result.searchParams.set('selectedIds', joinedIds);
    result.searchParams.set('preselectedIds', joinedIds);
  }

  return result.toString();
}
